import {
    ArrowsDownUpIcon,
    CheckSquareIcon,
    FunnelSimpleIcon,
    SquareIcon,
} from '@phosphor-icons/react';
import type { TFunction } from 'i18next';
import { ActionBarInteractionTrigger } from './ActionBarShell';
import { ActionType, ActiveIndicator } from './ActionBar.types';
import type {
    MenuAction,
    MenuItemConfig,
    ToggleAction,
} from './ActionBar.types';

export function buildSortAction(
    t: TFunction,
    items: MenuItemConfig[],
): MenuAction {
    return {
        type: ActionType.MENU,
        icon: ArrowsDownUpIcon,
        label: t('common:browseBar.sortBy'),
        title: t('common:browseBar.sortBy'),
        trigger: ActionBarInteractionTrigger.CLICK,
        items,
    };
}

interface FiltersActionOptions {
    isActive: boolean;
    items: MenuItemConfig[];
    onClear?: () => void;
}

export function buildFiltersAction(
    t: TFunction,
    { isActive, items, onClear }: FiltersActionOptions,
): MenuAction {
    return {
        type: ActionType.MENU,
        icon: FunnelSimpleIcon,
        label: t('common:browseBar.filters'),
        title: t('common:browseBar.filters'),
        trigger: ActionBarInteractionTrigger.CLICK,
        active: isActive,
        activeIndicator: ActiveIndicator.DOT,
        onClear: isActive ? onClear : undefined,
        items,
    };
}

export function buildMultiSelectToggle(
    t: TFunction,
    onEnter: () => void,
): ToggleAction {
    return {
        type: ActionType.TOGGLE,
        icon: SquareIcon,
        activeIcon: CheckSquareIcon,
        label: t('common:browseBar.multiSelect'),
        isActive: false,
        onClick: onEnter,
    };
}
